module.exports = __webpack_public_path__ + "media/team_photos/Matthias-Stokowy-photo-f6643741.webp";